import React from 'react';
import { Link } from 'react-router-dom';
import { currentDate } from '../../../core/helper';

export const HomeAuthFooter = () => {
    return (

        <>
        <div className="text-center mx-auto mt-auto w-100">
            <div className='border-top border-bottom mb-3 d-flex justify-content-around py-1 w-100'>
                <Link to="/contact-us" className="text-muted welcome-link p-2 small">Contact us</Link>
                <a href="https://www.trueadvance.com/" target="blank" className="text-muted welcome-link p-2 small">About True Advance</a>
                <a href="https://www.trueadvance.com/privacy-policy" target="blank" className="text-muted welcome-link p-2 small">Privacy Policy</a>
            </div>
            <p className='text-muted small mb-0'><i>Copyright True Leadership Solutions LLC. {currentDate()}. All rights reserved.</i></p>
        </div>
        </>
    )
}
